import { EmptyState, Loader, MaterialIcon, Page } from '@components';
import { RouterLink } from '@libs';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, Tooltip } from '@mui/material';
import { routes } from '@routes';
import AssessmentReportItem, { AssessmentReportItemActions } from '@StandingAccess/components/AssessmentReportItem';
import useStandingAccessReports from '@StandingAccess/hooks/use-standing-access-reports';
import { StandingAccessReportItem } from '@StandingAccess/types';

export default function StandingAccessReportsPage() {
  const { reports, isFetched, refetch, isRefetching } = useStandingAccessReports();

  const button = (
    <Stack direction="row" spacing={2} alignItems="center">
      {isFetched && (
        <Tooltip title="Refresh" placement="top" arrow>
          <LoadingButton onClick={() => refetch()} size="small" loading={isRefetching} color="inherit">
            <MaterialIcon symbol="refresh" weight={700} />
          </LoadingButton>
        </Tooltip>
      )}
      <Button variant="contained" component={RouterLink} to={routes.CreateStandingAccessReport.path}>
        New Assessment
      </Button>
    </Stack>
  );

  return (
    <Page title={routes.StandingAccessReports.label} button={button}>
      <StandingAccessReportsPageContent reports={reports} isFetched={isFetched} />
    </Page>
  );
}

interface StandingAccessReportsPageContentProps {
  reports: StandingAccessReportItem[];
  isFetched: boolean;
}

function StandingAccessReportsPageContent({ reports, isFetched }: StandingAccessReportsPageContentProps) {
  if (!isFetched) return <Loader />;

  if (reports.length === 0)
    return (
      <EmptyState
        title="No assessments found"
        body="Create a new assessment to get started"
        action={
          <Button href={routes.CreateStandingAccessReport.path} variant="contained">
            Create Assessment
          </Button>
        }
      />
    );

  return (
    <Stack direction="column" spacing={2}>
      {reports.map((report) => (
        <AssessmentReportItem key={report.report.id} report={report.report} integration={report.integration}>
          <AssessmentReportItemActions report={report.report} />
        </AssessmentReportItem>
      ))}
    </Stack>
  );
}
